module.exports = __webpack_public_path__ + "static/media/bottom_arrow.45d86567.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/bottom_arrow.svg
// module id = ./src/assets/media/forum/bottom_arrow.svg
// module chunks = 16